import { AddressID } from 'framework/address'
import { OrderID } from 'framework/orders'
import { OrderService } from '.'

export default class OrderAddressService extends OrderService {
  update(orderId: OrderID, newShippingValue: number, addressId: AddressID, farmers: number[] = []) {
    const payload = {
      address_id: addressId,
      total_shipping:
        typeof newShippingValue === 'string'
          ? parseFloat((newShippingValue as unknown as number).toFixed(2))
          : newShippingValue,
      farmers,
    }

    const url = `/orders/${orderId}/delivery-address-update`
    const req = this.setUrl(url).post(payload)
    return req
  }
}
